{
  "aiGeneratedAnswer": "Dirbtinio intelekto sugeneruotas atsakymas",
  "allCategories": "Visos kategorijos",
  "appliedFiltersToCurrentSearch": "Taikyti filtrai dabartiniam paieškai",
  "apply": "Taikyti",
  "applyFilters": "Taikyti filtrus",
  "autocompleteOptionsFound_few": "Rastos {{count}}{{label}} automatinio užbaigimo parinktys.",
  "autocompleteOptionsFound_many": "Rasta {{count}}{{label}} automatinio užbaigimo parinkčių.",
  "autocompleteOptionsFound_one": "Rasta {{count}}{{label}} automatinio užbaigimo parinktis.",
  "autocompleteOptionsFound_other": "Rasta {{count}}{{label}} automatinio užbaigimo parinkčių.",
  "autocompleteSuggestion": "automatinis užbaigimas pasiūlymas: {{suggestion}}",
  "autocompleteSuggestionsFound_few": "Rasti {{count}} automatinio užbaigimo pasiūlymai.",
  "autocompleteSuggestionsFound_many": "Rasta {{count}} automatinio užbaigimo pasiūlymų.",
  "autocompleteSuggestionsFound_one": "Rastas {{count}} automatinio užbaigimo pasiūlymas.",
  "autocompleteSuggestionsFound_other": "Rasta {{count}} automatinio užbaigimo pasiūlymų.",
  "basedOnYourDevice": " (remiantis jūsų įrenginiu)",
  "basedOnYourInternetAddress": " (remiantis jūsų interneto adresu)",
  "categoriesText_few": "Šios kategorijos pateikė rezultatus – <strong>{{query}}</strong>",
  "categoriesText_one": "Ši kategorija pateikė rezultatus – <strong>{{query}}</strong>",
  "categoriesText_other": "Šių kategorijų pateikta rezultatų – <strong>{{query}}</strong>",
  "clearAll": "Išvalyti viską",
  "clearMinAndMax": "Išvalyti min ir max",
  "clearTheRangeToSelectOptions": "Išvalykite diapazoną, kurį galite pasirinkti parinktys.",
  "clearTheSearchBar": "Išvalykite paieškos juostą",
  "conductASearch": "Atlikite paiešką",
  "currentLocation": "Dabartinė vieta",
  "didYouMean": "Ar turėjote omenyje <button>{{correctedQuery}}</button>",
  "dropDownScreenReaderInstructions": "Kai yra automatinio užbaigimo rezultatai, naudokite rodykles aukštyn ir žemyn naršymui ir Enter pasirinkimui.",
  "feedback": "Atsiliepimai",
  "filterGroupSearchInputLabel": "Ieškoti {{title}} parinkčių",
  "invalidRange": "Neteisingas diapazonas",
  "max": "Maks.",
  "min": "Min.",
  "navigateToTheNextResultsPage": "Eikite į kitą rezultatų puslapį",
  "navigateToThePreviousResultsPage": "Eikite į ankstesnį rezultatų puslapį",
  "noAutocompleteOptionsFound": "0 automaatse täitmise valikut ei leitud.",
  "noAutocompleteSuggestionsFound": "0 automaatse täitmise soovitust ei leitud.",
  "noResultsFoundIn": "Rezultatų nerasta {{currentVerticalLabel}}.",
  "paginationPage": "{{pageNumber}} puslapis",
  "pagination": "Puslapiavimas",
  "readMoreAbout": "Skaityti daugiau apie <a>{{name}}</a>",
  "recentSearch": "Naujausia paieška: {{query}}",
  "recentSearchesFound_few": "Rastos {{count}} neseniai atliktos paieškos.",
  "recentSearchesFound_many": "Rasta {{count}} neseniai atliktų paieškų.",
  "recentSearchesFound_one": "Rasta {{count}} neseniai atlikta paieška.",
  "recentSearchesFound_other": "Rasta {{count}} neseniai atliktų paieškų.",
  "removeFilter": "Pašalinti filtrą: „{{displayName}}“",
  "resultPreview": "rezultato peržiūra: {{value}}",
  "resultPreviewsFound_few": "Rastos {{count}} rezultatų peržiūros.",
  "resultPreviewsFound_many": "Rasta {{count}} rezultatų peržiūrų.",
  "resultPreviewsFound_one": "Rasta {{count}} rezultatų peržiūra.",
  "resultPreviewsFound_other": "Rasta {{count}} rezultatų peržiūrų.",
  "resultsCountText_few": "{{count}} rezultatai",
  "resultsCountText_many": "{{count}} rezultatų",
  "resultsCountText_one": "{{count}} rezultatas",
  "resultsCountText_other": "{{count}} rezultatų",
  "resultsCountWithPaginationText": "{{paginateStart}}–{{paginateEnd}} iš {{resultsCount}} rezultatų",
  "searchHere": "Ieškokite čia…",
  "showingAllInstead": "Vietoje to rodomi visi {{currentVerticalLabel}}.",
  "showLess": "Rodyti mažiau",
  "showMore": "Rodyti daugiau",
  "sources_few": "Šaltiniai ({{count}})",
  "sources_many": "Šaltinių ({{count}})",
  "sources_one": "Šaltinis",
  "sources_other": "Šaltinių ({{count}})",
  "submitSearch": "Pateikti paiešką",
  "suggestionResultsCount_few": "{{label}} – {{count}} rezultatai",
  "suggestionResultsCount_many": "{{label}} – {{count}} rezultatų",
  "suggestionResultsCount_one": "{{label}} – {{count}} rezultatas",
  "suggestionResultsCount_other": "{{label}} – {{count}} rezultatų",
  "thankYouForYourFeedback": "Ačiū už jūsų atsiliepimus!",
  "thisAnsweredMyQuestion": "Tai atsakė į mano klausimą",
  "thisDidNotAnswerMyQuestion": "Tai neatsakė į mano klausimą",
  "unselectAnOptionToEnterInARange": "Atžymėkite parinktį, kad galėtumėte įvesti intervalą.",
  "updateYourLocation": "Atnaujinkite savo vietą",
  "useCurrentLocation": "Naudoti dabartinę vietą",
  "useMyLocation": "Naudoti mano vietą",
  "viewAll": "Peržiūrėti visus",
  "viewDetails": "Peržiūrėti išsamią informaciją"
}
